// Lightweight Bible reference detection for the frontend.
// Matches patterns like "John 3:16", "Gen. 1:1-3", "1 Cor 13:4-7"

const BOOK_NAMES = [
  // Numbered books first (longest first to avoid partial matches)
  '1 Thessalonians', '2 Thessalonians', '1 Corinthians', '2 Corinthians',
  '1 Chronicles', '2 Chronicles', '1 Samuel', '2 Samuel', '1 Timothy', '2 Timothy',
  '1 Kings', '2 Kings', '1 Peter', '2 Peter', '1 John', '2 John', '3 John',
  '1 Thess', '2 Thess', '1 Cor', '2 Cor', '1 Chr', '2 Chr',
  '1 Sam', '2 Sam', '1 Tim', '2 Tim', '1 Kgs', '2 Kgs',
  '1 Pet', '2 Pet', '1 Jn', '2 Jn', '3 Jn',
  '1 Th', '2 Th', '1 Pe', '2 Pe',
  // Full names (longest first)
  'Song of Solomon', 'Ecclesiastes', 'Deuteronomy', 'Philippians',
  'Lamentations', 'Colossians', 'Revelation', 'Nehemiah', 'Zechariah',
  'Zephaniah', 'Habakkuk', 'Ephesians', 'Galatians', 'Proverbs',
  'Jeremiah', 'Ezekiel', 'Obadiah', 'Philemon', 'Hebrews', 'Genesis',
  'Exodus', 'Leviticus', 'Numbers', 'Joshua', 'Judges', 'Esther',
  'Isaiah', 'Daniel', 'Matthew', 'Romans', 'Haggai', 'Malachi',
  'Psalms', 'Psalm', 'Hosea', 'Micah', 'Nahum', 'Jonah',
  'Amos', 'Joel', 'Ruth', 'Acts', 'Mark', 'Luke', 'John', 'Jude',
  'Titus', 'James', 'Job',
  // Common abbreviations
  'Eccles', 'Chron', 'Thess', 'Deut', 'Josh', 'Judg', 'Prov',
  'Eccl', 'Ezek', 'Zech', 'Zeph', 'Phil', 'Phlm', 'Matt',
  'Song', 'Exod', 'Gen', 'Lev', 'Num', 'Neh', 'Est', 'Esth',
  'Isa', 'Jer', 'Lam', 'Eze', 'Dan', 'Hos', 'Hab', 'Hag',
  'Zec', 'Zep', 'Mal', 'Rom', 'Gal', 'Eph', 'Col', 'Tit',
  'Heb', 'Jas', 'Rev', 'Cor', 'Sam', 'Tim', 'Kgs', 'Chr',
  'Pet', 'Mic', 'Nah', 'Jnh', 'Jdg',
  'Psa', 'Php',
  'Mk', 'Lk', 'Jn', 'Ob', 'Mt', 'Ps',
  'Ex',
]

const bookPattern = BOOK_NAMES.map((b) => b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')

const BIBLE_REF_REGEX = new RegExp(
  `(${bookPattern})\\.?\\s*(\\d{1,3}):(\\d{1,3})(?:\\s*[-–—]\\s*(\\d{1,3}))?`,
  'gi'
)

export interface BibleRefMatch {
  reference: string  // The full matched text
  index: number      // Start position in original string
  length: number     // Length of matched text
}

export function detectBibleReferences(text: string): BibleRefMatch[] {
  const matches: BibleRefMatch[] = []
  BIBLE_REF_REGEX.lastIndex = 0

  let match: RegExpExecArray | null
  while ((match = BIBLE_REF_REGEX.exec(text)) !== null) {
    matches.push({
      reference: match[0].trim(),
      index: match.index,
      length: match[0].length,
    })
  }
  return matches
}
